export const PAYMENT_GET_PAYMENT_CLIENT_SECRET_REQUEST = "PAYMENT_GET_PAYMENT_CLIENT_SECRET_REQUEST";
export const PAYMENT_GET_PAYMENT_CLIENT_SECRET_SUCCESS = "PAYMENT_GET_PAYMENT_CLIENT_SECRET_SUCCESS";
export const PAYMENT_GET_PAYMENT_CLIENT_SECRET_FAIL = "PAYMENT_GET_PAYMENT_CLIENT_SECRET_FAIL";
